/**
 * @implements iImmutableResource
 */
export default class LanguagesResource
{
	#resource_adaptor
	#route_prefix = 'languages/';
	#route_postfix = '';

	/**
	 *
	 * @param Resource resource_adaptor
	 */
	constructor(resource_adaptor)
	{
		this.#resource_adaptor = resource_adaptor
	}

	get()
	{
		return this.#resource_adaptor.get(`${this.#route_prefix}${this.#route_postfix}`)
	}

	show(id)
	{
		return this.#resource_adaptor.get(`${this.#route_prefix}${this.#route_postfix}${id}`)
	}
	getNested(parent_id)
	{
		return this.#resource_adaptor.get(`${this.#route_prefix}${parent_id}/${this.#route_postfix}`)
	}

}